import React from "react";
import styled from 'styled-components';

const Collection = styled.div`
  display: flex;
  padding: 9px 28px;
  align-items: center;
  margin-left:-25px;
  margin-right:-25px;
  cursor: pointer;

  &:hover {
    background: rgba(35, 35, 35, 0.8);
  }

  .main-icon {
    background: rgba(21, 198, 125, 0.25);
    width: 48px;
    height: 48px;
    min-width: 48px;
    min-height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    margin-right: 18px;

    span {
      color: #15C67D;
      font-size: 24px;
    }
  }

  .text {
    .title {
      font-family: Roboto;      
      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
      color: #E5E5E5;
      margin-bottom: 3px;
    }

    .description {
      font-family: Open Sans;      
      font-weight: 400;
      font-size: 11px;
      line-height: 15px;
      color: #A0A0A0;
    }
  }
`;

const CollectionItem = ({ collection, goToDetailPage }) => {
  return (
    <Collection onClick={() => goToDetailPage(collection)}>
      <div className="main-icon">
        <span className="material-icons-outlined">
          {collection.icon}
        </span>
      </div>
      <div className="text">
        <p className="title">{collection.title}</p>
        <p className="description">{collection.text}</p>
      </div>
    </Collection>
  );
};

export default CollectionItem;
